import http from 'hub-http/clients/apiClient';
export default {
  fetchUsersByScope: scope => {
    return http.get(`users/v2/app/scopes/${scope}/hub-users`);
  }
};